import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Footer from './Components/Navbar/Footer';
import { Provider } from "react-redux";
import store from './store/store';
import { NetworkProvider } from './Components/Hooks/useNetworkCheck';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import theme from './theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // axiosClient already retries at the transport layer (axios-retry) —
      // retrying again here would stack up to 3x more attempts per query.
      retry: 0,
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter>
            <NetworkProvider>
              <App />
            </NetworkProvider>
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
